/* eslint-disable camelcase */
import { transition, LINEAR, TransformProperties } from './transitions';
import { Item, Order } from '@pegasus/types/order';

export function scrollToTop(duration: number = 1000): void {
    const body = document.getElementsByTagName('body')[0];
    const html = document.getElementsByTagName('html')[0];

    if (body) {
        transition(body, { scrollTop: 0 }, LINEAR, duration);
    }

    if (html) {
        transition(html, { scrollTop: 0 }, LINEAR, duration);
    }
}

export function scrollElement(
    element: HTMLElement,
    property: TransformProperties,
    duration: number = 1000,
): void {
    transition(element, property, LINEAR, duration);
}

/**
 *
 * @param elementId ID of the item which has to be brought to the viewport
 */
export const scrollElementToViewPort = (
    elementToBeScrolled?: HTMLElement | null,
    parentContainer?: HTMLElement | null,
) => {
    if (!elementToBeScrolled) {
        return;
    }

    const container = parentContainer || document.getElementsByTagName('html')[0];

    const contentBoxHeight = container.offsetHeight;
    const contentScrollTop = container.scrollTop;
    const elementToBeScrolledOffset = elementToBeScrolled.offsetTop;
    const elementToBeScrolledHeight = elementToBeScrolled.offsetHeight;
    const centerOfTheViewPort = contentBoxHeight / 2;
    const offsetValue = elementToBeScrolledOffset - contentBoxHeight + centerOfTheViewPort;

    // Check if the element to scroll is already in the viewport
    if (
        !(
            contentScrollTop < elementToBeScrolledOffset &&
            elementToBeScrolledOffset + elementToBeScrolledHeight <
                contentScrollTop + contentBoxHeight
        )
    ) {
        scrollElement(container, { scrollTop: offsetValue }, 500);
    }
};

export interface FromToDate {
    from: Date;
    to: Date;
}

function getDateRange(from?: string, to?: string): FromToDate | undefined {
    return from && to
        ? {
              from: new Date(from),
              to: new Date(to),
          }
        : undefined;
}

export function getDeliveryRange({ order_delivery_date_from, order_delivery_date_to }: Order) {
    return getDateRange(order_delivery_date_from, order_delivery_date_to);
}

export function getItemDeliveryRange({ delivery_date_from, delivery_date_to }: Item) {
    return getDateRange(delivery_date_from, delivery_date_to);
}

export function getYearsToFilter(): Date[] {
    const now = new Date();
    const past = new Date('01/01/2016');
    const years = now.getFullYear() - past.getFullYear();
    const list = [];
    for (let i = 0; i <= years; i++) {
        list.push(new Date(now.getFullYear() - i, 0, 1));
    }
    return list;
}

export const getCampaignNames = (items: Item[]): string[] =>
    Array.from<string>(
        new Set(
            items
                .map<string | undefined>(item => item.campaign_name)
                .filter((name: string | undefined): name is string => !!name),
        ),
    );

export const isWebView = () => typeof window !== 'undefined' && window.isWebview;

export const getCSRFToken = () => window.CSRF;

export * from './tracking';
